module.exports = __webpack_public_path__ + "img/shot_tx19112501.92441d4e.jpg";